
define('jst!conversations/_show',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="events-container">\n  <div class="started-on">\n    <%= translations.started_on.format(absoluteDateTime(conversation.get(\'created_on\'))) %>\n  </div>\n\n  <ul class="events">\n  </ul>\n  <div class="conversation-presence-bar-wrapper"></div>\n</div>\n');
 });

